export default __webpack_public_path__ + "static/media/yearn-logo.1b19a279.svg";